import { UtensilsCrossed, Award, Users } from 'lucide-react';

const About = () => {
  return (
    <section className="section-container" id="about">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div className="flex flex-col space-y-6 animate-fade-in-right">
          <div className="inline-flex items-center space-x-2">
            <div className="h-px w-8 bg-barbecue-500"></div>
            <span className="text-barbecue-500 font-medium">O NAS</span>
          </div>
          <h2 className="heading-lg">Tradicija in strast do pristne hrane</h2>
          <p className="paragraph">
            Žar & Bar Polskava je družinski lokal z večletno tradicijo, kjer se prepletata 
            ljubezen do dobre hrane in skrbno izbrana ponudba pijač. Naša zgodba se je začela 
            pred desetimi leti, ko smo združili kulinično znanje in gostoljubnost, da bi 
            ustvarili prostor, kjer se ljudje počutijo kot doma.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
            <div className="flex items-start space-x-3">
              <UtensilsCrossed className="text-barbecue-500 mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-lg">Pristni okusi</h3>
                <p className="text-sm text-foreground/80">Tradicionalne slovenske jedi z modernim pridihom</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Award className="text-barbecue-500 mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-lg">Kakovost</h3>
                <p className="text-sm text-foreground/80">Skrbno izbrane sestavine od lokalnih dobaviteljev</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Users className="text-barbecue-500 mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-lg">Gostoljubnost</h3>
                <p className="text-sm text-foreground/80">Domača atmosfera in prijazno osebje</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="relative h-[500px] animate-fade-in-left">
          <div className="absolute top-0 right-0 w-[80%] h-[80%] rounded-lg overflow-hidden shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
              alt="Žar priprava"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute bottom-0 left-0 w-[60%] h-[60%] rounded-lg overflow-hidden shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
              alt="Bar ambient"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;